import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getConnectionRequiredDialogOpen } from '../Selectors'
import { setConnectionRequiredDialog } from '../ActionCreators'
import ConnectionRequiredModal from '../../components/Modals/ConnectionRequiredModal'

/**
 * Modal for when attempting to pring to cloud printer while offline
 *
 * @returns {React.Element}
 */
export const VNConnectionRequired = () => {
  const dispatch = useDispatch()
  const isOpen = useSelector(getConnectionRequiredDialogOpen)

  const cancelHandler = useCallback(() => {
    dispatch(setConnectionRequiredDialog(false))
  }, [dispatch])

  if (!isOpen) {
    return null
  }

  // TODO: refactor component to use VNDialogs with equivalent styling
  return <ConnectionRequiredModal onButtonClick={cancelHandler} />
}
